export const sizesSubTitle = [
    {
        text: "You can change the size of avatar using ",
        code: '.img- *(70/80/90/100)'
    },
    {
        text: ' class.'
    }
];

export const statusSubTitle = [
    {
        text: "Add ",
        code: ' .status-*(online/offline/dnd)'
    },
    {
        text: ' class to set the status.'
    }
];

export const shapesSubTitle = [
    {
        text: "Use",
        code: '.b-r-*(8/30/35/25)'
    },
    {
        text: ' class shapes of avatar.'
    }
];

export const ratioSubTitle = [
    {
        text: "Give the shape to avatar using ",
        code: '.radio'
    },
    {
        text: ' and',
        code: ' img-*(50/70/80/90/100)'
    },
    {
        text: ' class.'
    }
];

export const groupSubTitle = [
    {
        text: "You can set the group of avatars using ",
        code: '.img-*(40/50/60/80/100) '
    },
    {
        text: '&',
        code: ' .b-r-* (8/30/35)'
    },
    {
        text: 'class.'
    }
]

export const avatarInitialSubTitle = [
    {
        text: "Use initial letter to set avatars.",
    }
]

export const avatarPingSubTitle = [
    {
        text: "To set ping animation use",
        code: ' .ping '
    },
    {
        text: 'class.',
    }
]

export const avatarProfileSubTitle = [
    {
        text: "Use icon and images as avatars profile.",
    }
]

export const avatarSizeData = [
    {
        class: 100,
        image: '3.jpg'
    },
    {
        class: 90,
        image: '4.jpg'
    },
    {
        class: 80,
        image: '7.jpg'
    },
    {
        class: 70,
        image: '11.jpg'
    }
]

export const avatarStatusData = [
    {
        class: 100,
        image: 'user/1.jpg',
        status: 'online'
    },
    {
        class: 90,
        image: 'avtar/16.jpg',
        status: 'dnd'
    },
    {
        class: 80,
        image: 'avtar/7.jpg',
        status: 'offline'
    },
    {
        class: 70,
        image: 'avtar/11.jpg',
        status: 'online'
    }
]

export const avatarShapeData = [
    {
        class: '100 b-r-8',
        image: '4.jpg'
    },
    {
        class: '90 b-r-30',
        image: '16.jpg'
    },
    {
        class: '80 b-r-35',
        image: '3.jpg'
    },
    {
        class: '70 rounded-circle',
        image: '11.jpg'
    }
]

export const avatarRatioData = [
    {
        class: 100,
        image: 'avtar/11.jpg'
    },
    {
        class: 90,
        image: 'avtar/4.jpg'
    },
    {
        class: 80,
        image: 'user/1.jpg'
    },
    {
        class: 70,
        image: 'avtar/16.jpg'
    },
    {
        class: 50,
        image: 'avtar/7.jpg'
    }
];

export const avatarGroupData = [
    {
        id: 1,
        child: [
            {
                id: 1,
                class: '100 b-r-8',
                image: 'avtar/4.jpg'
            },
            {
                id: 2,
                class: '80',
                image: 'avtar/16.jpg'
            },
            {
                id: 3,
                class: '50 b-r-35',
                image: 'avtar/3.jpg'
            },
        ]
    },
    {
        id: 2,
        child: [
            {
                id: 1,
                class: '60 rounded-circle',
                image: 'avtar/16.jpg'
            },
            {
                id: 2,
                class: '80 b-r-8',
                image: 'user/1.jpg'
            },
            {
                id: 3,
                class: '60 rounded-circle',
                image: 'avtar/16.jpg'
            },
        ]
    },
    {
        id: 3,
        child: [
            {
                id: 1,
                class: '40 rounded-circle',
                image: 'user/3.jpg'
            },
            {
                id: 2,
                class: '40 rounded-circle',
                image: 'user/5.jpg'
            },
            {
                id: 3,
                class: '40 rounded-circle',
                image: 'user/1.jpg'
            },
        ]
    },
]

export const avatarInitialData = [
    {id: 1, class: 80, color: 'primary', text:'A'},
    {id: 2, class: 70, color: 'secondary', text:'D'},
    {id: 3, class: 60, color: 'danger', text:'M'},
    {id: 4, class: 50, color: 'primary', text:'I'},
    {id: 5, class: 40, color: 'secondary', text:'R'},
    {id: 6, class: 30, color: 'danger', text:'O'},
]

export const avatarPingData = [
    {id: 1, class: 80, status: 'offline', src:'avtar/11.jpg'},
    {id: 2, class: 70, status: 'online', src:'avtar/4.jpg'},
    {id: 3, class: 60, status: 'dnd', src:'user/1.jpg'},
    {id: 4, class: 50, status: 'offline', src:'avtar/3.jpg'},
]